import React from 'react'

export const MarkerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 6.94931C12 10.4445 8.19194 14.0845 6.91319 15.2087C6.79406 15.2999 6.64905 15.3492 6.5 15.3492C6.35095 15.3492 6.20594 15.2999 6.08681 15.2087C4.80806 14.0845 1 10.4445 1 6.94931C1 5.46408 1.57946 4.03968 2.61091 2.98947C3.64236 1.93925 5.04131 1.34924 6.5 1.34924C7.95869 1.34924 9.35764 1.93925 10.3891 2.98947C11.4205 4.03968 12 5.46408 12 6.94931Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 9.04934C7.63909 9.04934 8.5625 8.10913 8.5625 6.94931C8.5625 5.7895 7.63909 4.84929 6.5 4.84929C5.36091 4.84929 4.4375 5.7895 4.4375 6.94931C4.4375 8.10913 5.36091 9.04934 6.5 9.04934Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
